import React from 'react'
import * as st from '~/assets/styl/Contact.module.styl'
import * as stBtn from '~/assets/styl/Button.module.styl'
import { Link, Form, Button } from '~/components'
import cn from 'classnames'
import { useLanguage } from '~/hooks'

export default function Contact() {
  const { t } = useLanguage()
  return (
    <section id="FaleConosco" className={st.core}>
      <div>
        <h2>{t('Contact.designDetail')}</h2>
        <p>
          {t('Contact.contactConsultants')}
          <br />
          {t('Contact.contactInfo')}
        </p>
        <Link
          href="https://api.whatsapp.com/send?phone=5548998295198"
          external
          className={cn(stBtn.core, st.whatsapp)}
        >
          <span className="icon-whatsapp"></span>
          {t('Contact.callWhatsApp')}
        </Link>
      </div>
      <Form
        path="conversions"
        idPrefix="contact"
        hiddenInputs={{
          token_rdstation: '529cac2f361142d6e1232668a5dbe8f9',
          identificador: 'dvert-hotsite',
        }}
        inputs={[
          {
            name: 'name',
            label: t('Contact.name'),
          },
          {
            name: 'email',
            label: t('Contact.email'),
            type: 'email',
          },
          {
            name: 'telefone',
            label: t('Contact.phone'),
            type: 'tel',
            mask: 'phone',
          },
          {
            name: 'purpose',
            label: t('Contact.purchasePurpose'),
            placeholder: 'Selecione',
            type: 'select',
            options: [
              {
                name: t('Contact.residence'),
              },
              {
                name: t('Contact.investment'),
              },
            ],
          },
          {
            name: 'dormitories',
            label: t('Contact.howManyBedrooms'),
            placeholder: 'Selecione',
            type: 'select',
            options: [
              {
                name: t('Contact.suites2'),
              },
              {
                name: t('Contact.suites3'),
              },
              {
                name: t('Contact.threeBedroomsTwoSuites'),
              },
            ],
          },
          {
            name: 'privacy',
            label: t('Contact.acceptanceStatement'),
            type: 'checkbox',
          },
        ]}
        button={<Button className={st.btn}>{t('Contact.buttonSend')}</Button>}
      />
    </section>
  )
}
